app.controller("SubjectIndexController", ["$scope", "Subject", "StaticData", "$uibModal", "ConfirmModal", "$stateParams", "$state", "toastr", "usSpinnerService", "$location",
    function ($scope, Subject, StaticData, $uibModal, ConfirmModal, $stateParams, $state, toastr, usSpinnerService, $location) {
        $scope.subjects = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;
        $scope.level = $stateParams.level;
        var isCtrlPressed;
        var modalOpened = false;

        if ($stateParams.prerequisite) {
            Subject.fetchOne($stateParams.prerequisite).then(function (data) {
                $scope.prerequisite = data.subject;
            });
        }

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{ name: "საფეხური" }].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            Subject.list({
                page: page,
                limit: $scope.itemsPerPage,
                query: $stateParams.query,
                level: $scope.level,
                prerequisite: $stateParams.prerequisite
            }).then(function (data) {
                $scope.subjects = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                level: $scope.level,
                prerequisite: $scope.prerequisite ? $scope.prerequisite._id : undefined
            });
        };


        $scope.goToPage = function (page) {
            $state.go(".", { page: page });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "AddSubjectController",
                templateUrl: _pb + 'admin/subject/add-subject.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    loadPage($scope.currentPage);
                    modalOpened = false;
                }, function () {
                });
        };

        $scope.edit = function (subject) {
            $uibModal.open({
                controller: "EditSubjectController",
                templateUrl: _pb + 'admin/subject/edit-subject.html',
                size: "md",
                resolve: {
                    subjectId: function () {
                        return subject._id;
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($scope.currentPage);
                }, function () {
                });
        };

        $scope.syllabus = function (subject) {
            $state.go("admin.subject-syllabus", { subjectId: subject._id, action: 'edit' });
        };

        $scope.showDetails = function (subject) {
            $state.go("admin.subject-details", { subjectId: subject._id });
        };

        function onKeyDown(e) {
            if (e.keyCode === 17) {
                isCtrlPressed = true;
            } else if (e.keyCode === 73) {
                if (isCtrlPressed) {
                    if (!modalOpened) {
                        $scope.add();
                        modalOpened = true;
                    }
                }
            }
        }

        function onKeyup(e) {
            if (e.keyCode === 17) {
                isCtrlPressed = false;
            }
        }

        document.addEventListener('keydown', onKeyDown);
        document.addEventListener('keyup', onKeyup);

        $scope.$on('$destroy', function () {
            document.removeEventListener('keydown', onKeyDown);
            document.removeEventListener('keyup', onKeyup);
        });

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.list({ query: query }).then(function (data) {
                return data.docs;
            });
        };

        $scope.remove = function (subject, $event) {
            var subjectId = subject._id;

            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "საგნის წაშლა",
                message: "თქვენ შლით საგანს -  " + subject.name + ". გსურთ საგნის წაშლა ?"
            }).result.then(function () {
                Subject.remove(subjectId).then(function () {
                    return loadPage($scope.currentPage)
                }).catch(function (err) {
                    if (err.status === 400) {
                        toastr.error('', 'საგანი მიბმულია პროგრამაზე !');
                    }
                })
            });
        }
        $scope.exportSyllabus = function (subject) {
            var name = subject.name;
            name = name.replace(/[&$%@#!?`'"|\/<>{}*+,;:^]/g, "");
            return `${location.origin}/syllabuses/export/${subject._id}/${name}`;
        }
    }
]);
